import React, { ReactNode } from 'react';
import cc from 'classnames';
import { useTheme, useMediaQuery } from '@material-ui/core';
import NavigateBack, { BackThemes } from '../NavigateBack/NavigateBack';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './NavigationTitle.module.css';

export enum LayoutType {
  auth = 'auth',
  dashboard = 'dashboard',
  support = 'support',
}

type Props = {
  children: ReactNode;
  to: string;
  layoutType?: LayoutType;
  className?: string;
  onClick?: () => void;
  noArrow?: boolean;
};

const NavigationTitle = ({ to, children, layoutType = LayoutType.auth, className, onClick, noArrow }: Props) => {
  const theme = useTheme();
  const downSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const titleClassName = cc(styles.title, styles[`${layoutType}Title`]);
  const showBackArrow = (downSmall || layoutType !== LayoutType.dashboard) && !noArrow;

  return (
    <div className={cc(styles.backWrapper, className)}>
      {showBackArrow && (
        <NavigateBack
          to={to}
          theme={downSmall ? BackThemes.button : BackThemes.link}
          className={styles.arrow}
          onClick={onClick}
        >
          {!downSmall && layoutType !== LayoutType.dashboard && 'Back'}
        </NavigateBack>
      )}
      <div className={titleClassName}>{children}</div>
    </div>
  );
};

export default NavigationTitle;
